const Loading = () => (<div>Loading...</div>)

export default Loading;